import React from "react";
import { useState } from "react";
import { useFirstTheme, usePaymentLink } from "./page";
import {
  Autocomplete,
  Box,
  Button,
  Collapse,
  Radio,
  TextField,
} from "@mui/material";
// import CvvInfo from "./cvvInfo";

import phonepayIcon from "../assets/phonepay.svg";
import paytmIcon from "../assets/paytm.svg";
import bhimIcon from "../assets/bhimlogo.svg";
import gpayIcon from "../assets/gpaylogo.svg";
import addmoreIcon from "../assets/addmore.svg";
import bandhanBankSvg from "../assets/bandhanbanks.svg";

import upiAnimatedIcon from "../assets/upiAnimated3.svg";
import creditDebitIcon from "../assets/creditDebit3.svg";
import payLaterIcon from "../assets/payLater3.svg";
import netBankingIcon from "../assets/netBanking3.svg";

import paylaterIcon from "../assets/paylater.svg";
// import LazyPayIcon from "../assets/LazyPay.svg";
// import simplIcon from "../assets/getsimplIcon.svg";

import axixbankIcon from "../assets/axisbank.svg";
import hdfcbankIcon from "../assets/hdfcbank.svg";
import icicibankIcon from "../assets/icicibank.svg";
import kotakbankIcon from "../assets/kotakbank.svg";
import sbibankIcon from "../assets/sbibank.svg";

import axixbankSvg from "../assets/axisbank.svg";
import hdfcbankSvg from "../assets/hdfcbank.svg";
import icicibankSvg from "../assets/icicibank.svg";
import kotakbankSvg from "../assets/kotakbank.svg";
import sbibankSvg from "../assets/sbibank.svg";

import crossArrowIcon from "../assets/crossArrow.svg";
import { removeWhiteSpace } from "../utils/splitByNum";
import { useFirstModule } from "../provider/invoiceProvider";
import Popup from "../components/popup";
import { initiateInvoiceTransaction } from "../services/initiateInvoiceTransaction";
// import informationIcon from "../assets/information.svg";

interface CountryType {
  code: string;
  label: string;
  img?: string;
}

interface CardDataType {
  txn_mode: "DC" | "CC";
  card_number: string;
  card_holder_name: string;
  card_cvv: string;
  card_expiry_date: string;
}

interface CardDataTypeError {
  txn_mode?: string;
  card_number?: string;
  card_holder_name?: string;
  card_cvv?: string;
  card_expiry_date?: string;
}

export default function ThirdPaymentType() {
  const [isExpanded, setIsExpanded] = useState(" ");
  const { invoiceLink, updateTheme } = useFirstTheme();
  const { linkData, updatePaymentLink } = usePaymentLink();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [trigger, setTrigger] = React.useState(false);
  const { invoiceData } = useFirstModule();
  // const [showCvvInfo, setCvvInfo] = React.useState(false);

  const [htmlContent, setHtmlContent] = React.useState<string>("");
  const [isPopupOpen, setIsPopupOpen] = React.useState<boolean>(false);
  const [cardData, setCardData] = React.useState<CardDataType>({
    txn_mode: "DC",
    card_number: "",
    card_holder_name: "",
    card_cvv: "",
    card_expiry_date: "",
  });

  const [cardDataError, setCardDataError] = React.useState<CardDataTypeError>({
    txn_mode: "",
    card_number: "",
    card_holder_name: "",
    card_cvv: "",
    card_expiry_date: "",
  });
  const [selectedBank, setSelectedBank] = React.useState("");

  const fetchHtmlContent = async () => {
    if (validateCardData(cardData)) {
      openPopup();
      try {
        const response = await fetch(
          "https://backend.vaamozdevelop.xyz/VampayLiveApi/EasebuzzDebitPayment",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Origin: "https://vaamoz.com",
            },
            body: JSON.stringify({
              ...cardData,
              amount: invoiceData?.payable_amount,
            }),
          },
        );
        const html = await response.text();
        setHtmlContent(html);
      } catch (error) {
        console.error("Error fetching HTML:", error);
      }
    }
  };

  const handleCardChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;
    if (name === "card_number") {
      value = removeWhiteSpace(value);
    }
    setCardData({ ...cardData, [name]: value });
  };

  const handleCardTypeChange = () => {
    const cardType = cardData?.txn_mode === "DC" ? "CC" : "DC";

    setCardData({ ...cardData, txn_mode: cardType });
  };

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const paymentMethods = [
    {
      icon: phonepayIcon,
      name: "Phone Pe",
      link: "",
      appName: "phonepe",
    },
    {
      icon: paytmIcon,
      name: "Paytm",
      link: "",
      appName: "paytm",
    },
    {
      icon: bhimIcon,
      name: "BHIM",
      link: "",
      appName: "bhim",
    },
    {
      icon: gpayIcon,
      name: "Gpay",
      link: "",
      appName: "gpay",
    },
  ];

  const paymentType = [
    {
      id: 1,
      name: "UPI",
      link: "",
      image: upiAnimatedIcon,
    },
    {
      id: 2,
      name: "Credit/Debit",
      link: "",
      image: creditDebitIcon,
    },
    {
      id: 3,
      name: "Pay Later",
      link: "",
      image: payLaterIcon,
    },
    {
      id: 4,
      name: "Net Banking",
      link: "",
      image: netBankingIcon,
    },
  ];

  const payLaterArray = [
    {
      name: "ICICI Pay later",
      icon: paylaterIcon,
      value: "",
    },
    {
      name: "LazyPay",
      icon: paylaterIcon,
      value: "",
    },
    {
      name: "Simpl",
      icon: paylaterIcon,
      value: "",
    },
  ];

  const netBankingArray = [
    {
      name: "Axis Bank",
      icon: axixbankIcon,
      value: "",
    },
    {
      name: "HDFC Bank",
      icon: hdfcbankIcon,
      value: "",
    },
    {
      name: "ICICI Bank",
      icon: icicibankIcon,
      value: "",
    },
    {
      name: "Kotak Bank",
      icon: kotakbankIcon,
      value: "",
    },
    {
      name: "SBI Bank",
      icon: sbibankIcon,
      value: "",
    },
  ];

  const redirectToPaymentApp = async (selectedGateway: string) => {
    let dataLink = invoiceLink?.link;
    if (!trigger) {
      const data = await initiateInvoiceTransaction(invoiceData);
      // console.log(trigger, "-<><><>>>>>>----->");
      updateTheme({
        link: data?.link,
        order_id: data?.order_id,
      });

      dataLink = data?.link;
      setTrigger(true);
    }

    let paymentLink;
    switch (selectedGateway) {
      case "gpay":
        // window.location.href = `googlepay://upi/transaction?pa=${encodeURIComponent(
        //   paymentLink
        // )}`;
        paymentLink = dataLink?.replace("upi://", "tez://upi/");
        updatePaymentLink({
          link: paymentLink,
          app: "gpay",
          upiId: "",
        });
        break;
      case "phonepe":
        // window.location.href = `phonepe://upi/transaction?pa=${encodeURIComponent(
        //   invoiceLink?.link
        // )}`;
        paymentLink = dataLink?.replace("upi://", "phonepe://");
        updatePaymentLink({
          link: paymentLink,
          app: "phonepe",
          upiId: "",
        });
        break;
      case "paytm":
        // window.location.href = `paytm://upi/transaction?pa=${encodeURIComponent(
        //   invoiceLink?.link
        // )}`;
        paymentLink = dataLink?.replace("upi://", "paytmmp://");
        updatePaymentLink({
          link: paymentLink,
          app: "paytm",
          upiId: "",
        });
        break;
      case "bhim":
        // window.location.href = `bhim://upi/transaction?pa=${encodeURIComponent(
        //   invoiceLink?.link
        // )}`;
        paymentLink = dataLink?.replace("upi://", "upi://pay?");
        updatePaymentLink({
          link: paymentLink,
          app: "bhim",
          upiId: "",
        });
        break;

      // case "addmore":
      //   // window.location.href = `bhim://upi/transaction?pa=${encodeURIComponent(
      //   //   invoiceLink?.link
      //   // )}`;
      //   paymentLink = invoiceLink?.link;
      //   updatePaymentLink({
      //     link: paymentLink,
      //     app: "addmore",
      //   });
      //   break;
      default:
        console.error("Unsupported payment gateway");
    }
  };

  const netBankingType: readonly CountryType[] = [
    { code: "AXB", label: "Axis Bank ", img: axixbankSvg },
    {
      code: "BANB",
      label: "Bandhan Bank",
      img: bandhanBankSvg,
    },
    { code: "HDFCB", label: "HDFC Bank", img: hdfcbankSvg },
    {
      code: "ICICIB",
      label: "ICICI Bank",
      img: icicibankSvg,
    },
    {
      code: "SBOI",
      label: "State Bank of India",
      img: sbibankSvg,
    },
  ];

  const validateCardData = (data: CardDataType) => {
    const ErrorObj: CardDataTypeError = {};
    let isValid = true;

    const checkNumber = /^\d+$/;
    const checkExpiry = /^(0[1-9]|1[0-2])\/\d{2}$/;
    const checkNameValidity = /^[A-Za-z\s]+$/;

    if (data?.card_number === "" && !checkNumber.test(data?.card_number)) {
      ErrorObj.card_number = "Kindly Enter a Valid Card Number";
      isValid = false;
    }
    // if (data?.amount === "" && !checkNumber.test(data?.amount)) {
    //   ErrorObj.amount = "Kindly Enter a Valid Payable Amount";
    //   isValid = false;
    // }

    if (data?.card_cvv === "" && !checkNumber.test(data?.card_cvv)) {
      ErrorObj.card_cvv = "Kindly Enter a Valid CVV";
      isValid = false;
    }

    if (
      data?.card_expiry_date === "" &&
      !checkExpiry.test(data?.card_expiry_date)
    ) {
      ErrorObj.card_expiry_date = "Kindly Enter a Valid Expiry Date";
      isValid = false;
    }

    if (
      data?.card_holder_name === "" &&
      !checkNameValidity.test(data?.card_holder_name)
    ) {
      ErrorObj.card_holder_name = "Kindly Enter a Valid Name";
      isValid = false;
    }

    setCardDataError({
      ...cardDataError,
      ...ErrorObj,
    });
    return isValid;
  };

  const handleNetBankingSubmit = async () => {
    openPopup();
    try {
      const response = await fetch(
        "https://backend.vaamozdevelop.xyz/VampayLiveApi/EasebuzzNetBanking",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Origin: "https://vaamoz.com",
          },
          body: JSON.stringify({
            amount: invoiceData?.payable_amount,
            bank: selectedBank,
          }),
        },
      );
      const html = await response.text();

      setHtmlContent(html);
    } catch (error) {
      console.error("Error fetching HTML:", error);
    }
  };

  const handleSelectionChange = (event: React.SyntheticEvent, value: any) => {
    value?.code && setSelectedBank(value?.code);
  };

  return (
    <div className="flex flex-col gap-4">
      {paymentType.map((item, index) => (
        <div key={index} className="relative bg-white border-2 rounded-2xl">
          <div
            className={`relative overflow-hidden  flex justify-center items-center  w-full h-32  transition-all duration-500 ease-in-out cursor-pointer`}
            onClick={() => {
              setIsExpanded((val) => (item.name === val ? " " : item.name));
              updatePaymentLink({
                link: "",
                app: "",
                upiId: "",
              });
            }}
          >
            <div
              className={`absolute top-4 right-4 ${
                item.name === isExpanded ? "-rotate-180" : ""
              } transition-all duration-500 ease-in-out`}
            >
              <img src={crossArrowIcon} alt={"logo"} height={20} width={20} />
            </div>
            <div
              className={`absolute  ${
                item.name === isExpanded ? "-translate-y-4" : ""
              }   transition-all duration-500 ease-in-out`}
            >
              <img src={item?.image} alt={"logo"} height={100} width={100} />
            </div>
          </div>

          <Collapse
            in={isExpanded === "UPI" && isExpanded === item.name}
            // timeout={{ appear: 500, enter: 500, exit: 500 }}
            timeout="auto"
            unmountOnExit
            sx={{ display: "flex", flexDirection: "row" }}
          >
            <div
              className="flex flex-wrap justify-between gap-3 p-4 bg-white rounded-3xl"
              // style={{ transition: "height 0.5s ease-in-out" }}
            >
              {paymentMethods.map((item, index) => (
                <button
                  onClick={() => {
                    redirectToPaymentApp(item.appName);
                  }}
                  key={index}
                  className={`p-1 w-1/5 flex flex-col justify-start items-center gap-2 ${
                    linkData?.app === item.appName
                      ? "border border-purple-500 rounded-sm bg-white"
                      : null
                  }`}
                >
                  <img src={item.icon} alt="." height={40} width={40} />
                  <p className="text-wrap">{item.name}</p>
                  {/* <p
                    className={`text-wrap ${
                      linkData?.app === item.appName
                        ? "text-[14px]"
                        : "text-[#ABABAB]"
                    }`}
                  >
                    {item.name}
                  </p> */}
                </button>
              ))}
            </div>
          </Collapse>
          <Collapse
            in={isExpanded === "Credit/Debit" && isExpanded === item.name}
            timeout="auto"
            unmountOnExit
            sx={{ display: "flex", flexDirection: "row" }}
          >
            <div className="flex flex-wrap gap-3 p-4 bg-white rounded-3xl">
              <div className="flex items-center justify-between w-full p-2 border rounded-md ">
                <input
                  placeholder="Card Number"
                  className="w-full bg-transparent outline-none"
                />
                {/* <img
                src={"../assets/tag.svg"}
                alt="logo"
                height={30}
                width={30}
                className="ml-2"
              /> */}
              </div>
              <input
                placeholder="Name on card"
                className="w-full p-2 bg-transparent border rounded-md outline-none"
              />
              <div className="flex gap-3">
                <input
                  name="card_expiry_date"
                  placeholder="Valid Thru (MM/YY)"
                  className={`w-2/3 p-2 bg-transparent border rounded-md outline-none ${
                    cardDataError?.card_expiry_date ? "border-red-500" : ""
                  }`}
                  value={cardData?.card_expiry_date}
                  onChange={handleCardChange}
                />
                <div className="flex items-center justify-between w-1/3 p-2 border rounded-md ">
                  <input
                    placeholder="CVV"
                    className="overflow-x-hidden bg-transparent rounded-md outline-none"
                  />
                  <button onClick={handleClick}>
                    {/* <img
                      src={informationIcon}
                      alt="logo"
                      height={30}
                      width={30}
                      className="m-1"
                    /> */}
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
          <Collapse
            in={isExpanded === "Pay Later" && isExpanded === item.name}
            timeout="auto"
            unmountOnExit
          >
            <div className="flex flex-col p-2 bg-white rounded-3xl">
              {payLaterArray.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-4 border-b border-dashed"
                >
                  <div className="flex items-center gap-4">
                    <img src={item.icon} alt="." height={40} width={40} />
                    <p>{item.name}</p>
                  </div>
                  <div>
                    {/* <img src={item.icon} alt="." height={40} width={40} />
                     */}
                    <Radio
                      checked={false}
                      // onChange={handleChange}
                      value="b"
                      name="radio-buttons"
                      inputProps={{ "aria-label": "B" }}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 25,
                          background: "white",
                          borderRadius: 10,
                        },
                        margin: 0,
                        padding: 0,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </Collapse>
          <Collapse
            in={isExpanded === "Net Banking" && isExpanded === item.name}
            timeout="auto"
            unmountOnExit
          >
            {/* <div className="flex flex-col p-2 bg-white rounded-3xl">
              {netBankingArray.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-4 border-b border-dashed"
                >
                  <div className="flex items-center gap-4">
                    <img src={item.icon} alt="." height={40} width={40} />
                    <p>{item.name}</p>
                  </div>
                  <div>
                    <Radio
                      checked={false}
                      // onChange={handleChange}
                      value="b"
                      name="radio-buttons"
                      inputProps={{ "aria-label": "B" }}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 25,
                          background: "white",
                          borderRadius: 10,
                        },
                        margin: 0,
                        padding: 0,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div> */}

            <div className="bg-[#F5F5F5] flex flex-col px-2 p-2 gap-4">
              {/* {netBankingArray.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-4 border-b border-dashed"
                >
                  <div className="flex items-center gap-4">
                    <img src={item.icon} alt="." height={40} width={40} />
                    <p>{item.name}</p>
                  </div>
                </div>
              ))} */}
              <Autocomplete
                fullWidth
                id="country-select-demo"
                options={netBankingType}
                autoHighlight
                getOptionLabel={(option) => option.label}
                onChange={handleSelectionChange}
                renderOption={(props, option) => {
                  const { ...optionProps } = props;
                  return (
                    <Box
                      // key={key}
                      component="li"
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...optionProps}
                    >
                      <img loading="lazy" width="20" src={option?.img} alt="" />
                      {option.label}
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Choose a Bank"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password",
                    }}
                  />
                )}
              />
              <Button
                variant="contained"
                onClick={handleNetBankingSubmit}
                disabled={
                  !(
                    invoiceData?.payable_amount !== "" &&
                    selectedBank !== "" &&
                    Number(invoiceData?.payable_amount) > 0
                  )
                }
              >
                Submit
              </Button>
            </div>
          </Collapse>
        </div>
      ))}
      {/* <CvvInfo
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        handleClick={handleClick}
        handleClose={handleClose}
      /> */}

      <Popup
        htmlContent={htmlContent}
        onClose={closePopup}
        isOpen={isPopupOpen}
      />
    </div>
  );
}
